import React from 'react';
import { GoldPlaque } from './GoldPlaque';
type SectionHeadingProps = {
  id: string;
  eyebrow: string;
  lead: string;
  highlight: string;
  intro?: string;
  tone?: 'dark' | 'light';
};
export function SectionHeading({
  id,
  eyebrow,
  lead,
  highlight,
  intro,
  tone = 'dark'
}: SectionHeadingProps) {
  return <div className="mx-auto max-w-3xl text-center" data-id="element-293" data-mp="rwpyoj5prlik">
      <GoldPlaque tone={tone} data-id="element-294" data-mp="s043rz5ri8tp">{eyebrow}</GoldPlaque>
      <h2 id={id} className="mt-6 font-display text-[38px] font-bold uppercase leading-[0.98] sm:text-[52px] lg:text-[60px]" data-id="element-295" data-mp="mzgbzb9plnyf">
        {lead} <span className={tone === 'dark' ? 'text-gold' : 'text-gold-dark'} data-id="element-296" data-mp="d8v6d3vmbj60">{highlight}</span>
      </h2>
      {intro && <p className={`mx-auto mt-5 max-w-2xl text-base leading-relaxed sm:text-lg ${tone === 'dark' ? 'text-white/80' : 'text-[#374151]'}`} data-id="element-297" data-mp="8aju6mhuowkm">
          {intro}
        </p>}
    </div>;
}